import { initLoggerAdapters, InitLoggerAdaptersParams } from '@mews-commander/modules';
import { PlatformEnvironment } from '@mews/enums';
import { createLoggerService as createService } from '@mews/framework';

type CreateLoggerServiceParams = Pick<
    InitLoggerAdaptersParams,
    | 'appClockService'
    | 'applicationInsightsInstrumentationKey'
    | 'environment'
    | 'newRelicLoggerConfig'
    | 'sentryReporterService'
>;

export const createLoggerService = ({
    appClockService,
    applicationInsightsInstrumentationKey,
    environment,
    newRelicLoggerConfig,
    sentryReporterService,
}: CreateLoggerServiceParams) => {
    const loggerAdapters = initLoggerAdapters({
        appClockService,
        applicationInsightsInstrumentationKey,
        appVersion: __VERSION__,
        environment,
        isProduction: environment === PlatformEnvironment.Production,
        newRelicLoggerConfig,
        sentryReporterService,
    });

    return createService({
        loggerAdapters,
    });
};
